module.exports = __webpack_public_path__ + "img/aomen2.642eb922.jpg";